export default "<ion-card mode=\"ios\">\n\t<div echarts [options]=\"renderOptions\" style=\"width:100%\"></div>\n</ion-card>";